export const tabsElements = [
  {
    title: 'Activities',
    component: () => <></>,
  },
  {
    title: 'Information',
    component: () => <></>,
  },
  {
    title: 'Access and Permissions',
    component: () => <></>,
  },
];
